// Step 1 
// Get the Membership ProductStep
import Product from '../product-component/product'
import TagManager from 'react-gtm-module';
import Helper from '../../common/helper';

export default function ProductStep({currentStep, languages, locationDataCurrency, locationData, products, selectMembership, isProductLoaded, error, stepNo, couponObj, isUserLogged, businessCategories}) {

  

  if (parseInt(currentStep) !== parseInt(stepNo)) {
    return null;
  } 
  //GTM initialize

  if(window.dataLayer.filter(a => a.pageCategory === 'Join now').length < 1) {
    TagManager.dataLayer(Helper.gtmPageView("", "Join now", "logged-out", ""))
  } 
  if(window.dataLayer.filter(a => a.checkoutStep === 1).length < 1) {
    TagManager.dataLayer(Helper.gtmFunnelPage(locationData.currency, 1, "", window.location.pathname, "", []))
  }
 
  return(
    <div className='card-wrapper flex justify-evenly'>
      <Product 
        languages            = {languages}
        locationData         = {locationData}
        isProductLoaded      = {isProductLoaded}
        error                = {error}
        products             = {products}
        selectMembership     = {selectMembership}
        locationDataCurrency = {locationDataCurrency}
        couponObj            = {couponObj}
        isUserLogged         = {isUserLogged}
        businessCategories   = {businessCategories}
      />
    </div>
  );
}